(() => {
  const pickRandom = (items) => {
    if (!Array.isArray(items) || items.length === 0) return null;
    return items[Math.floor(Math.random() * items.length)];
  };

  const applyProduct = (card, product) => {
    if (!product) return;

    const link = card.querySelector('[data-rr-yml-link]');
    const image = card.querySelector('.rr-yml__image:not(.rr-yml__image--placeholder)');
    const title = card.querySelector('[data-rr-yml-title]');
    const price = card.querySelector('[data-rr-yml-price]');
    const badge = card.querySelector('[data-rr-stock-badge]');

    if (link && product.url) {
      link.setAttribute('href', product.url);
    }

    if (title && product.title) {
      title.textContent = product.title;
    }

    if (price && product.price) {
      price.textContent = product.price;
    }

    if (image && product.image) {
      image.setAttribute('src', product.image);
      if (product.srcset) {
        image.setAttribute('srcset', product.srcset);
      }
      if (product.title) {
        image.setAttribute('alt', product.title);
      }
      if (product.width) {
        image.setAttribute('width', String(product.width));
      }
      if (product.height) {
        image.setAttribute('height', String(product.height));
      }
    }

    if (badge) {
      const badgeData = product.badge;
      if (badgeData && badgeData.label) {
        badge.textContent = badgeData.label;
        badge.hidden = false;
        badge.classList.toggle('rr-stock-badge--sold-out', Boolean(badgeData.sold_out));
      } else {
        badge.textContent = '';
        badge.hidden = true;
        badge.classList.remove('rr-stock-badge--sold-out');
      }
    }
  };

  const initCard = (card) => {
    if (card.dataset.rrYmlReady === 'true') return;

    const jsonNode = card.querySelector('[data-rr-yml-products]');
    if (!jsonNode) return;

    let products = [];

    try {
      products = JSON.parse(jsonNode.textContent.trim());
    } catch (error) {
      return;
    }

    card.dataset.rrYmlReady = 'true';

    if (!Array.isArray(products) || products.length < 2) return;

    applyProduct(card, pickRandom(products));
  };

  const init = (root = document) => {
    for (const card of root.querySelectorAll('[data-rr-yml-card]')) {
      initCard(card);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
